module.exports = __webpack_public_path__ + "assets/1366ad5d82999642b8bfb5a7d3636504.svg";